import React, { Component } from "react";

import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Button,
  Label,
  // Input,
  Container,
  // CustomInput,
  // InputGroup,
  // Form,
  // InputGroupAddon,
} from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";

import { connect } from "react-redux";

import {
  getSettings,
  SettingsInputChangeValue,
  SettingsSave
} from "../../store/System/actions";

class SystemSettings extends Component {
  constructor(props) {
    super(props);

    this.state = {
      
    };

    this.handleValidSubmit = this.handleValidSubmit.bind(this);
   
  }
  
  componentDidMount() {

    this.props.getSettings()
  }

  ChangeHandeler(e) {
    this.props.SettingsInputChangeValue({
      key: e.target.name,
      value: e.target.value,
    });
  }
  handleValidSubmit(event, values) {
    this.props.SettingsSave(values, this.props.history);
  }
  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Card>
              <CardHeader className="bg-transparent border-bottom">
                <h3 className="card-title-18 pt-2">System Settings</h3>
              </CardHeader>
              <CardBody>
                <Row className="justify-content-center">
                  <Col xs={9}>
                    <Card>
                      <CardBody>
                        <h4 className="card-title-18">Update Settings</h4>
                        <AvForm
                            className="form-horizontal"
                            onValidSubmit={this.handleValidSubmit}
                            // ref={(c) => (this.addForm = c)}
                          >
                          <Row className="justify-content-center">
                            <Col xs={9}>
                            <FormGroup row>
                                <Col md={4}>
                                  <Label
                                    htmlFor="rfq_timedelta_hr"
                                    className="col-form-label float-right"
                                  >
                                  RFQ Link Exp Time in Hr 
                                  </Label>
                                </Col>
                                <Col md={8}>
                                  <AvField
                                    className="form-control"
                                    type="text"
                                    id="rfq_timedelta_hr"
                                    name="rfq_timedelta_hr"
                                    value ={this.props.settings?.rfq_timedelta_hr}
                                    
                                    onChange={(e)=>this.ChangeHandeler(e)}
                                    validate={{
                                      required: { value: true },
                                    }}
                                  />
                                </Col>
                              </FormGroup>
                              <div className="float-right">
                                <Button type="submit" color="light"
                                className="mr-2"
                                >
                                  Cancel
                                </Button>
                                <Button
                                  type="submit"
                                  color="primary"
                                >
                                  Submit
                                </Button>
                          
                              </div>
                            </Col>
                          </Row>

                        </AvForm>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  
  const {  settings,  } = state.System;

  return {
    settings
  };
};
export default connect(mapStatetoProps, {
  getSettings,
  SettingsInputChangeValue,
  SettingsSave
})(SystemSettings);
